import {HTTP} from '@/CallAPI'

export default {
  getListStatus () {
    return HTTP.get('checklist-item-status')
  },

  showStatus (status) {
    return HTTP.get('checklist-item-status/' + status.id)
  },

  destroyStatus (status) {
    return HTTP.delete('checklist-item-status/' + status.id)
  },

  createStatus (status) {
    return HTTP.post('checklist-item-status', status)
  },

  updateStatus (status) {
    return HTTP.put('checklist-item-status/' + status.id, status)
  }
}



// WEBPACK FOOTER //
// ./src/service/checklist-item-status.js